import React from "react";
import RequestDetailsContainer from "containers/VendorDetails/RequestViewDetail/index";

const RequestDetails = (props) => {
  return (
    <>
      <RequestDetailsContainer
      {...props}
      
       />
    </>
  ); 
};

export default RequestDetails;